import { render, staticRenderFns } from "./ProfileDialogue.vue?vue&type=template&id=fd05be5e&lang=true&"
import script from "./ProfileDialogue.vue?vue&type=script&lang=js&"
export * from "./ProfileDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports